export const joinPaths = (...paths: string[]) => paths.join('/').replace(/([^:])\/{2,}/g, '$1/')
